



































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {mapGetters} from "vuex";

import Toast from "@/script/message";

@Component({
    computed: {...mapGetters(["user"])},
    components: {},
})
export default class UserGeneralSetting extends Vue {
    toast = new Toast();
    private user!: any;
    private isCommentOn: boolean = false;
    private isLikeOn: boolean = false;
    private isFollowOn: boolean = false;
    private isMentionOn: boolean = false;
    private isRetweetOn: boolean = false;
    private isDmOn: boolean = false;

    private fileName: string = "";
    private prevProfile: any = ''
    private updateFile: File | null = null;

    mounted() {

        this.prevProfile = this.user.picture
    }


    async switchOnOff(type: string) {
        if (type === "comment") {
            this.isCommentOn = !this.isCommentOn;
        }
        else if (type === "like") {
            this.isLikeOn = !this.isLikeOn;
        }
        else if (type === "follow") {
            this.isFollowOn = !this.isFollowOn;
        }
        else if (type === "mention") {
            this.isMentionOn = !this.isMentionOn;
        }
        else if (type === "retweet") {
            this.isRetweetOn = !this.isRetweetOn;
        }
        else if (type === "dm") {
            this.isDmOn = !this.isDmOn;
        }

        // await this.$api.alarmOnOff(type);
    }


    userInfo() {
        try {
            return this.user;
        }
        catch (error) {
        }
    }

    uploadFile() {
        (this.$refs.profileImg as HTMLElement).click();
    }

    onFileChange(event: { target: { files: any } }) {
        if (event.target.files[0].size < 1024 * 1024 * 3) {
            this.fileName = event.target.files[0].name
            this.updateFile = event.target.files[0]
            const reader = new FileReader();
            reader.onload = e => {
                this.prevProfile = e.target!.result
            };
            reader.readAsDataURL(event.target.files[0]);
        }
        else {
            alert(`최대 파일 크기는 3mb입니다. `)
        }

    }

    uploadProfile() {
        const formData = new FormData();
        if (this.updateFile) {
            formData.append('file', this.updateFile);
            formData.append('name', this.user.name)

            this.$api.updateUser(formData)
                .then((res) => {
                    this.toast.successToast(`${this.$t('userSetting.done')}`)//""
                    // this.$store.dispatch('userInfoUpdate', res.picture)

                    // console.log(' this.$store.getters.user.picture',  res)

                    this.$store.commit('userInfoUpdate', {
                        picture:res.user.picture ? res.user.picture + `?t=${Date.now()}` : null
                    });
                })
        }else{
            formData.append('rm_picture', 'true');
            this.$api.updateUser(formData)
                .then(() => {
                    this.toast.successToast(`${this.$t('userSetting.done')}`)
                    // this.$store.dispatch('userInfoUpdate', res.picture)

                    this.$store.commit('userInfoUpdate', {
                        picture:null
                    });
                })
        }

    }

    deleteImg(e) {
        this.prevProfile = '';
        this.fileName = '';
        e.stopPropagation()

    }

}
